import React, { useEffect, useState, useRef } from "react";
import {
  Alert,
  Button,
  Col,
  Form,
  Input,
  Modal,
  Row,
  Spin,
  message,
  Table,
  Typography,
} from "antd";
import { ArrowRightOutlined, LoadingOutlined } from "@ant-design/icons";
import SimpleReactValidator from "simple-react-validator";
import UserServices from "../../services/UserServices";
import { translate } from "../../locale";

const { Search } = Input;

const { Title } = Typography;

const AddAdministrator = ({ companyId, visible, onComplete, onCancel }) => {
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);
  const [active, setActive] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [values, setValues] = useState({
    position: "",
  });
  const [, forceUpdate] = useState();

  const simpleValidator = useRef(
    new SimpleReactValidator({
      autoForceUpdate: { forceUpdate: forceUpdate },
      element: (message) => (
        <div className="text-red-600 pt-2 text-xs">{message}</div>
      ),
      messages: {
        required: "Campo requerido",
      },
    })
  );

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (value, record, index) => (
        <div className="flex space-x-4 justify-center">
          <Button
            type="text"
            icon={<ArrowRightOutlined />}
            size="small"
            className="border-0"
            onClick={() => {
              handleSelectUser(record);
            }}
          />
        </div>
      ),
      width: 100,
    },
    {
      title: translate("Usuario"),
      dataIndex: "username",
      key: "username",
    },
    {
      title: translate("Apellido"),
      dataIndex: "last_name",
      key: "last_name",
    },
    {
      title: translate("Nombre"),
      dataIndex: "first_name",
      key: "first_name",
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
    },
  ];

  useEffect(() => {}, []);

  useEffect(() => {
    if (visible !== null) {
      setActive(visible);
      if (visible === true) {
        loadAdminUsers();
      }
    }
  }, [visible]);
  const disabled = () => !simpleValidator.current.allValid();

  const loadAdminUsers = async () => {
    try {
      const response = await UserServices.getContacts();
      if (response.status >= 200 && response.status < 300) {
        let users = [...response.data.contacts.coordinators];

        setData(users);
        setFilteredData(users);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      setError(e.message);
      setLoading(false);
    }
  };

  const onSearch = (value) => {
    setFilteredData(
      data.filter(
        (i) =>
          i.username.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
          i.last_name.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
          i.first_name.toLowerCase().indexOf(value.toLowerCase()) > -1
      )
    );
  };

  const resetForm = () => {
    setError("");
    setValues({
      position: "",
    });
    setSelectedData(null);
    simpleValidator.current.hideMessages();
    simpleValidator.current.visibleFields = [];
    forceUpdate();
  };

  const handleCancel = () => {
    resetForm();
    setActive(false);
    if (onCancel) {
      onCancel();
    }
  };

  const handleSelectUser = (data) => {
    console.log("data", data);
    setSelectedData(data);
  };

  const onFinish = async () => {
    setSaving(true);
    setError("");
    if (!simpleValidator.current.allValid()) {
      simpleValidator.current.showMessages();
      forceUpdate();
      setError(translate("Todos los datos son requeridos"));
      return;
    }
    try {
      console.log({
        enterprise: companyId,
        manager: selectedData.username,
        position: values.position,
      });
      const response = await UserServices.saveManagement({
        enterprise: companyId,
        manager: selectedData.username,
        position: values.position,
      });
      if (response.status >= 200 && response.status < 300) {
        if (onComplete) {
          onComplete(data);
        }
        message.success(
          translate(
            "El {0} se guardó exitosamente.",
            translate("usuario administrador")
          )
        );
        resetForm();
      } else {
        setError(response.data.message);
      }
      // setFilteredData(response.data);
      setSaving(false);
    } catch (e) {
      console.log(e);
      setError(e.message);
      setSaving(false);
    }
  };

  const handleChange = (name, value) => {
    setValues((v) => ({ ...v, [name]: value }));
  };

  const handleBlur = (e) => {
    const { name, value } = e.target;
    simpleValidator.current.showMessageFor(name);
    setValues((v) => ({ ...v, [name]: value }));
  };

  return (
    <Modal
      open={active}
      title={translate("Agregar administrador")}
      onOk={null}
      onCancel={handleCancel}
      footer={false}
      width="80%"
    >
      <Title level={4}>{translate("Buscar usuario")}</Title>

      <Search
        placeholder="Email"
        allowClear
        size="large"
        name="email"
        onSearch={onSearch}
        loading={loading}
        className="max-w-sm mb-6"
        enterButton={translate("Buscar")}
      />

      <Table dataSource={filteredData} columns={columns} rowKey={(i) => i.id} />

      {selectedData !== null && (
        <div className="flex flex-col justify-center items-center absolute left-0 top-0 right-0 bottom-0 w-full h-full bg-white/90">
          <div className="w-full max-w-sm text-left">
            <Title level={5}>{translate("Posición")}</Title>
            <Form
              initialValues={{ remember: true }}
              onFinish={onFinish}
              autoComplete="off"
            >
              <Form.Item>
                <Input
                  placeholder="Puesto"
                  className="border-custom_primary"
                  name="position"
                  onChange={(e) => handleChange("position", e.target.value)}
                  onBlur={handleBlur}
                  value={values.position}
                />
                {simpleValidator.current.message(
                  "position",
                  values.position,
                  "required"
                )}
              </Form.Item>
              {error && (
                <Alert
                  message={error}
                  type="error"
                  className="mb-6"
                  closable
                  onClose={() => setError("")}
                />
              )}
              <Form.Item>
                <Row align="end" gutter={16}>
                  <Col>
                    <Button key="back" onClick={() => setSelectedData(null)}>
                      Cancelar
                    </Button>
                  </Col>
                  <Col>
                    <Button
                      disabled={disabled() || saving}
                      htmlType="submit"
                      type="primary"
                      className="bg-custom_primary"
                    >
                      {saving ? (
                        <Spin
                          indicator={
                            <LoadingOutlined style={{ color: "#666666" }} />
                          }
                        />
                      ) : (
                        translate("Guardar")
                      )}
                    </Button>
                  </Col>
                </Row>
              </Form.Item>
            </Form>
          </div>
        </div>
      )}
    </Modal>
  );
};

export default AddAdministrator;
